import { render, staticRenderFns } from "./MenuTabValues.vue?vue&type=template&id=531c1b6d&scoped=true"
import script from "./MenuTabValues.vue?vue&type=script&lang=js"
export * from "./MenuTabValues.vue?vue&type=script&lang=js"
import style0 from "./MenuTabValues.vue?vue&type=style&index=0&id=531c1b6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c1b6d",
  null
  
)

export default component.exports